module.exports = __webpack_public_path__ + "static/media/copy-link-icon.126015e8.svg";